import { RoleSelectorBootstrap } from "../Common/RoleSelector";
import { useAuth } from "../../contexts/auth/useAuth";
import { RoleLevel, roles, type User } from "../../types/Users";
import { useTrads } from "../../contexts/trads/useTrads";
import { useForm } from "react-hook-form"
import { Navigate } from "react-router";
import { useUpdateUserMutation } from "../../stores/OkOkStore";
import { SendUserValidationErrorNotification } from "../../services/WebServices";

interface Props  {
    userParam: Partial<User> & Pick<User,'id'>;
    messages: string[]
    setMessages: React.Dispatch<React.SetStateAction<string[]>>
    setVersion: React.Dispatch<React.SetStateAction<number>>
    version:number
};

export default function UserValidation({userParam,messages,setMessages,setVersion,version}: Props){

    function removeMessage(index:number){
        setMessages(messages.filter((_,i)=> i!=index));
    }

    const [updateUser,result]=useUpdateUserMutation();
    
    const {userRole} = useAuth();
    const { register, handleSubmit, formState: { errors }  } = useForm({
        defaultValues:userParam,
        shouldUseNativeValidation: true,
        mode:'onBlur',
    });
    const sendMail= async function(){
       
        await SendUserValidationErrorNotification(
            {dest:userParam.id,params:{messages:messages}}
        ).then(()=>{
            setMessages([]);
            setVersion(version+1);

        });
        return;
    }


    const {translate}=useTrads();

    return (
        result.isSuccess ? <Navigate to={`/user/${result.data.id.toString()}`} state={{modified:"true"}}></Navigate> :(
        result.error ? <p className="p-3 mb-2 bg-danger text-white">{translate('page_load_error')}</p>:
        result.isLoading ? <p className="p-3 mb-2 bg-info text-white">{translate('page_loading')}</p>:
        <>
        <form className="row" onSubmit={(event) =>void handleSubmit(updateUser)(event)}>
            <div className="col-12  mb-3">
                <RoleSelectorBootstrap
                    label={translate('user_role')}
                    name="rangacces"
                    registerOutput={register("rangacces", {
                        required: translate("user_error_role_requis"),
                    })}
                    maxlevel={RoleLevel[userRole??roles.Visitors]}
                    errors={errors}
                    rest={{disabled:messages.length>0}}
                />
            </div>
            {messages.length==0?
            <div className="col-12  mb-3">
                <button type="submit">{translate('form_submit')}</button>
            </div>
            :null}
        
        </form>
        {messages.length?
        <div>
            <h4>{translate('user_validation_errors')}</h4>
            <div>
                {messages.map((e,i)=>(
                    <p key={e}>{e} <a onClick={()=>{ removeMessage(i); }}><i className="bi bi-trash"></i></a></p>
                ))}
            </div>

            <button onClick={()=>{ void sendMail(); }}>{translate('send_error_validation_mail')}</button>

        </div>
        :null
        }

        </>
        )
    )
}